import { Array, Filter } from 'effect'

import { VIEW_NEW_RECORD_PREFIX } from './constant'

export const partitionPickedRecordIds = (
  pickedIds: string[],
): {
  newRecordIds: string[]
  existingRecordIds: string[]
} => {
  const [newRecordIds, existingRecordIds] = Array.partition(
    pickedIds,
    Filter.fromPredicate((id) => id.startsWith(VIEW_NEW_RECORD_PREFIX)),
  )
  return { newRecordIds, existingRecordIds }
}
